const  modals = {
    name          : 'modals',
    _modals       : null,
    _closes       : null,

    init() {
        this.run();
    },

    run()
    {
        setTimeout(this.initModalBtn, 1000);
        this.initModalClose();
    },

    initModalClose()
    {
        this._closes = document.querySelectorAll('.js_modal-close');

        if (!this._closes) {
            return;
        }

        for (const el of this._closes) {
            el.addEventListener('click', function(el) {
                const modal = this.closest('.my-account-modal');
                modal.classList.remove('active');
            });
        }
    },

    initModalBtn()
    {
        this._modals = document.querySelectorAll('.js_modal-btn');
        if (!this._modals) {
            return;
        }

        for (const modal of this._modals) {
            modal.addEventListener('click', function(el) {
                const modalBoxId = this.dataset.target;
                document.getElementById(modalBoxId).classList.add('active');
            });
        }
    }
}


export { modals };